import { IconModel } from "models";
import React from "react";
import { SvgCommon } from "./SvgCommon";

export const UploadIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <mask
        id="mask0_656_7450"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="15"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.50004 9.33301C2.86823 9.33301 3.16671 9.63148 3.16671 9.99967V12.6663C3.16671 12.8432 3.23695 13.0127 3.36197 13.1377C3.48699 13.2628 3.65656 13.333 3.83337 13.333H13.1667C13.3435 13.333 13.5131 13.2628 13.6381 13.1377C13.7631 13.0127 13.8334 12.8432 13.8334 12.6663V9.99967C13.8334 9.63148 14.1319 9.33301 14.5 9.33301C14.8682 9.33301 15.1667 9.63148 15.1667 9.99967V12.6663C15.1667 13.1968 14.956 13.7055 14.5809 14.0806C14.2058 14.4556 13.6971 14.6663 13.1667 14.6663H3.83337C3.30294 14.6663 2.79423 14.4556 2.41916 14.0806C2.04409 13.7055 1.83337 13.1968 1.83337 12.6663V9.99967C1.83337 9.63148 2.13185 9.33301 2.50004 9.33301Z"
          fill="#2F2F2F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.02864 1.52827C8.28899 1.26792 8.7111 1.26792 8.97145 1.52827L12.3048 4.8616C12.5651 5.12195 12.5651 5.54406 12.3048 5.80441C12.0444 6.06476 11.6223 6.06476 11.362 5.80441L8.50004 2.94248L5.63811 5.80441C5.37776 6.06476 4.95565 6.06476 4.6953 5.80441C4.43495 5.54406 4.43495 5.12195 4.6953 4.8616L8.02864 1.52827Z"
          fill="#2F2F2F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.50004 1.33301C8.86823 1.33301 9.16671 1.63148 9.16671 1.99967V9.99967C9.16671 10.3679 8.86823 10.6663 8.50004 10.6663C8.13185 10.6663 7.83337 10.3679 7.83337 9.99967V1.99967C7.83337 1.63148 8.13185 1.33301 8.50004 1.33301Z"
          fill="#2F2F2F"
        />
      </mask>
      <g mask="url(#mask0_656_7450)">
        <rect x="0.5" width="16" height="16" fill="white" />
      </g>
    </SvgCommon>
  );
};

UploadIcon.defaultProps = {
  size: [17, 16],
  viewBox: [17, 16],
};
